import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { getCoreDataSecurityAccessComparisonSlice } from './get';

import {
	coreDataSecurityAccessComparisonByObjectIdReducers,
	coreDataSecurityAccessComparisonByObjectIdWatchers
} from './object';
import {
	coreDataSecurityAccessComparisonExportReducers,
	coreDataSecurityAccessComparisonExportWatchers
} from './export';

export const coreDataSecurityAccessComparisonReducers = combineReducers({
	export: coreDataSecurityAccessComparisonExportReducers,
	get: getCoreDataSecurityAccessComparisonSlice.asyncReducers,
	object: coreDataSecurityAccessComparisonByObjectIdReducers
});

export const coreDataSecurityAccessComparisonWatchers = combineAllWatchers([
	getCoreDataSecurityAccessComparisonSlice.asyncWatchers,
	coreDataSecurityAccessComparisonByObjectIdWatchers,
	coreDataSecurityAccessComparisonExportWatchers
]);
